import _ from 'lodash';
import chartColors from '../../../shared/js/lib/chartColors';
import DashboardNavigation from '../components/DashboardNavigation';
import React, { PropTypes } from 'react';
import { Doughnut, HorizontalBar } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import {
	getDoughnutChartData,
	getDoughnutChartOptions,
	getStudentMovesChartData,
	getTeacherMovesChartData,
	getMovesChartOptions
} from '../lib/dashboardCharts';

let DashboardOverview = React.createClass({
	propTypes: {
		observation: PropTypes.object.isRequired,
		router: PropTypes.object.isRequired,
		studentEventTypes: PropTypes.array.isRequired,
		teacherEventTypes: PropTypes.array.isRequired
	},

	getPersonObservations: function() {
		return this.props.observation.student_observations.concat(this.props.observation.teacher_observations);
	},

	render: function() {
		return (
			<div className="observation-overview">
				<div className="row observation-dashboard-header">
					<div className="col-md-8">
						<h2>
							Observation Overview
						</h2>
						<h4>
							Students observed for { this.props.observation.number_of_cycles * this.props.observation.student_minutes } minutes, teacher observed for { this.props.observation.number_of_cycles * this.props.observation.teacher_minutes } minutes
						</h4>
					</div>
					<div className="col-md-4">
						<DashboardNavigation observation={ this.props.observation } router={ this.props.router } />
					</div>
				</div>
				<div className="dashboard-card dashboard-hint">
					<h3>What Your Data Means</h3>
					<p>These graphs give a summary of the types of instruction that were observed in your classroom as well as the context in which that instruction was given.  You can also see the kinds of talk you and your students participated in during the observation.</p>
				</div>

				<div className="row">
					<div className="col-md-6">
						<div className="dashboard-card chart-card">
							<h3>Content</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<Doughnut
									data={ getDoughnutChartData(this.getPersonObservations(), 'observation_subject') }
									options={ getDoughnutChartOptions() }
								/>
							</div>
						</div>
					</div>

					<div className="col-md-6">
						<div className="dashboard-card chart-card">
							<h3>Context</h3>
							<p>Minutes Observed</p>
							<div className="chart-container">
								<Doughnut
									data={ getDoughnutChartData(this.getPersonObservations(), 'observation_context') }
									options={ getDoughnutChartOptions() }
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-6">
						<div className="dashboard-card chart-card">
							<h3>Student Moves</h3>
							<p>Observed Occurrences</p>
							<div className="chart-container" style={ { height: '500px' } }>
								<HorizontalBar
									data={ getStudentMovesChartData(this.props.studentEventTypes, this.props.observation.student_observations) }
									options={ getMovesChartOptions() }
								/>
							</div>
						</div>
					</div>

					<div className="col-md-6">
						<div className="dashboard-card chart-card">
							<h3>Teacher Moves</h3>
							<p>Observed Occurrences</p>
							<div className="chart-container" style={ { height: '700px' } }>
								<HorizontalBar
									data={ getTeacherMovesChartData(this.props.teacherEventTypes, this.props.observation.teacher_observations) }
									options={ getMovesChartOptions() }
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
});

module.exports = DashboardOverview;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/DashboardOverview.jsx